import React from 'react';

const FilterLoadingItem = ({ label }) => {
  return (
    <>
      <h3 className="text-left text-base font-semibold">{label}</h3>
      <div role="status" className="rounded animate-pulse">
        <div className="h-5 bg-gray-200 mb-3" />
        <div className="h-5 bg-gray-200 mb-3" />
        <div className="h-5 bg-gray-200 mb-3" />
        <div className="h-5 bg-gray-200 mb-3" />
        <div className="h-5 bg-gray-200 mb-3" />
        <span className="sr-only">Loading...</span>
      </div>
    </>
  );
};

export default FilterLoadingItem;
